import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-30f46ee4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "treeView",
  class: "component-groups-tree-container"
}
const _hoisted_2 = { style: {"width":"100%","padding-left":".388rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_Memo = _resolveComponent("Memo")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      width: 400,
      trigger: "click"
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", {
          class: "tree-popover-wrapper",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stopEventPropagation && _ctx.stopEventPropagation(...args)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.selectedComponents.length)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  closable: "",
                  onClick: _ctx.onComponentTagClick,
                  onClose: _cache[0] || (_cache[0] = (e) => _ctx.onComponentTagCloseClick(_ctx.selectedComponents[0].value, e))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedComponents[0].label), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.selectedComponents.length > 1)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  style: {"margin":"0 .3rem"},
                  onClick: _ctx.stopEventPropagation
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" + " + _toDisplayString(_ctx.selectedComponents.length), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (!_ctx.selectedComponents.length)
              ? (_openBlock(), _createBlock(_component_el_text, {
                  key: 2,
                  style: {"padding-left":".388rem","color":"var(--el-text-color-placeholder)"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Фильтр по группам компонентов ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            (!_ctx.componentGroupsTree?.length)
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  onClick: _ctx.stopEventPropagation,
                  class: "show-tree-icon disabled",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Memo)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_el_icon, {
                  key: 1,
                  class: "show-tree-icon",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Memo)
                  ]),
                  _: 1
                }))
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, { class: "component-groups-scrollbar" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tree, {
              loading: _ctx.isAsyncOperationPending,
              ref: "elTree",
              class: "component-groups-tree",
              "show-checkbox": "",
              "check-strictly": "",
              "node-key": "value",
              data: _ctx.componentGroupsTree,
              props: { children: 'children', label: 'label' },
              "filter-node-method": _ctx.filterGrpupsTree,
              onCheckChange: _ctx.onTreeChange
            }, {
              empty: _withCtx(() => [
                _createTextVNode("   ")
              ]),
              _: 1
            }, 8, ["loading", "data", "filter-node-method", "onCheckChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 512))
}